import { useApi, useVimUserMetadata } from '@getvim/internal-vim-os-sdk/react';
import { useEffect, useMemo, useState } from 'react';
import { UserConfig } from '../types';

export const useSdkAdapterConfig = (): UserConfig['adapterConfig'] => {
  const { manifestSupport } = useVimUserMetadata();
  const { resourceUpdater } = useApi();

  const [referralAuthCode, setReferralAuthCode] = useState<boolean>(
    resourceUpdater.canUpdateReferral({
      basicInformation: { authCode: true },
    }).canUpdate,
  );

  const [orderTargetProvider, setOrderTargetProvider] = useState<boolean>(
    resourceUpdater.canUpdateOrder({
      targetProvider: true,
    }).canUpdate,
  );

  useEffect(() => {
    const referralCb = () => {
      setReferralAuthCode(
        resourceUpdater.canUpdateReferral({
          basicInformation: { authCode: true },
        }).canUpdate,
      );
    };

    const orderCb = () => {
      setOrderTargetProvider(
        resourceUpdater.canUpdateOrder({
          targetProvider: true,
        }).canUpdate,
      );
    };

    resourceUpdater.subscribe('referral', referralCb);
    resourceUpdater.subscribe('orders', orderCb);

    return () => {
      resourceUpdater.unsubscribe('referral', referralCb);
      resourceUpdater.unsubscribe('orders', orderCb);
    };
  }, [resourceUpdater]);

  return useMemo(() => {
    return {
      vimConnectCapabilities: {
        supportsUpdateReferral: Object.values(
          manifestSupport?.EHR.resourcePermissions?.referral || {},
        ).some((v) => v.write),
        supportsUpdateOrder:
          Object.values(manifestSupport?.EHR.resourcePermissions?.orders || {}).some(
            (v) => v.write,
          ) && orderTargetProvider,
      },
      unsupportedWritebackFields: {
        updateReferral: referralAuthCode ? [] : ['authCode'],
      },
    };
  }, [
    manifestSupport?.EHR.resourcePermissions?.referral,
    manifestSupport?.EHR.resourcePermissions?.orders,
    referralAuthCode,
    orderTargetProvider,
  ]);
};
